<template>
  <van-popup
      class="popup-box"
      v-model:show="isShow"
      position="center"
      :close-on-click-overlay="false"
  >
    <div class="recharge_popup_out">
      <div class="recharge_popup">
        <div class="title_box">
          <p class="title_box_desc">{{ product?.name }}</p>
        </div>
        <div class="content_box">
          <div class="price_desc">
            <p>{{ product?.description }}</p>
          </div>
          <div class="price_btn" @click="handlePay">
            <div class="price-bubble-box">
              <img src="~/assets/images/reader/icon-pay-price-bubble.png" alt="">
              <!--    试用商品倒计时      -->
              <PersistentCountdown @finish="close" :cycleDuration="10*60*1000" class="package-item-off"
                                   ref="persistentCountdown"></PersistentCountdown>
              <!--              <p v-else class="daily_price">${{ showProduct.dailyPrice }}/day</p>-->
            </div>
           <div v-if="product?.discount_price">
             <p class="weekly_price">${{ product?.discount_price }}{{ cycleUnit(product.cycle_unit) }}</p>
             <p class="old_weekly_price">${{ product?.price }}</p>
           </div>
            <div v-else>
              <p class="weekly_price">${{ product?.price }}{{ cycleUnit(product.cycle_unit) }}</p>
            </div>
          </div>
          <p class="price_tips">{{ $t('auto_renew_cancel_anytime') }}</p>
        </div>
        <img @click="close" class="close_btn" src="~/assets/images/reader/icon-reader-popup-close.png" alt="">
      </div>
    </div>
  </van-popup>
</template>

<script setup lang="ts">
import PersistentCountdown from '~/components/PersistentCountdown/index.vue'

const emit = defineEmits(['openPayPopup', 'close'])
const {t} = useI18n()
const isShow = ref(false)
const product = ref(null)
const persistentCountdown = ref(null)
const close = () => {
  isShow.value = false
  removeLocalStore('payment_info')
  emit('close')
  eventBus.emit('reload_after_close')
}

const cycleUnit = (cycle_unit: string) => {
  const unit = {
    'daily': t('reader.day'),
    'weekly': t('reader.week'),
    'monthly': t('reader.month'),
    'yearly': t('reader.year'),
  }
  return unit[cycle_unit]
}

const handlePay = async () => {
  emit('openPayPopup', 'PayPopup', {...product.value}, true)
}

const open = (p: any) => {
  console.log('会员挽留弹窗接收到挽留商品数据', p)
  isShow.value = true
  product.value = p

}
defineExpose({
  open,
})
</script>

<style scoped lang="scss">
.van-popup {
  background: transparent;
  margin: 0;
  max-width: 100% !important;
  font-family: SFPro, SFPro;

  .recharge_popup_out {
    width: 100vw;
    margin: auto;
    display: flex;
    justify-content: center;

    .recharge_popup {
      position: relative;
      width: 340px;
      height: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      transform: scale(0.9);


      .title_box {
        width: 100%;
        height: 125px;
        background: url("~/assets/images/reader/icon-pay-title-bg.png");
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        position: relative;
        z-index: -1;
        transform: translateY(25px);

        img {
          width: 100%;
        }

        .title_box_desc {
          width: 50%;
          font-weight: 600;
          font-size: 22px;
          color: #FFFFFF;
          line-height: 30px;
          text-shadow: 0 4px 6px #EF5746;
          text-align: left;
          font-style: normal;
          position: absolute;
          left: 12%;
          top: calc(50% - 8px);
          transform: translateY(-50%);
        }
      }

      .content_box {
        width: 100%;
        aspect-ratio: 100 / 73;
        background: url("~/assets/images/reader/icon-pay-recharge-bg.png");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        padding: 15px 21px 5px;
        display: flex;
        flex-direction: column;
        align-items: center;
        //gap: 15px;

        .price_desc {
          width: 100%;
          height: 90px;
          background: url("~/assets/images/reader/icon-pay-content-bg.png");
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          position: relative;
          padding: 21px 68px 21px 21px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 6px;
          margin-top: 18px;

          .price_off_bg {
            width: 62px;
          }

          .price_off_content {
            position: absolute;
            width: 65px;
            height: 65px;
            top: -30px;
            right: -30px;
            transform: rotate(30deg);
            display: flex;
            color: #FFFFFF;
            font-weight: 600;
            align-items: center;
            justify-content: center;

            .price_off_num {
              font-size: 25px;
            }

            .price_off {
              display: flex;
              flex-direction: column;
              font-size: 10px;
              text-align: center;
              justify-content: center;

              span:nth-child(1) {
                font-size: 11px;
              }
            }
          }

          p {
            font-weight: 600;
            font-size: 18px;
            color: #932929;
            line-height: 25px;
            text-align: left;
            font-style: normal;
          }

          .corner_marker {
            position: absolute;
            width: 62px;
            top: -30px;
            right: -30px;

            .discount {
              position: absolute;
              font-size: 23px;
              color: #ffffff;
              font-weight: 600;
              transform: rotate(32deg);
              top: 15px;
              left: 14px;
            }
          }
        }

        .price_btn {
          width: 100%;
          height: 83px;
          background: url("@/assets/images/reader/icon-pay-content-btn-bg.png");
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          position: relative;
          color: #FFFFFF;
          text-align: center;
          //padding: 5px 0 5px 0;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

          .price-bubble-box {
            width: 84px;
            height: 24px;
            position: absolute;
            right: 13px;
            top: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;

            img {
              width: 100%;
            }

            .daily_price {
              width: 100%;
              height: auto;
              position: absolute;
              top: -2px;
              color: #FFFFFF;
              font-size: 12px;
              text-align: center;
              font-weight: 600;
              line-height: 26px;
            }

            .package-item-off {
              width: 100%;
              text-align: center;
              position: absolute;
              //left: 50%;
              top: 10px;
              transform: translate(0px, -50%);
              font-size: 11px !important;
              font-weight: 600;
              color: #FFFFFF;
            }
          }

          .weekly_price {
            font-size: 19px;
            font-weight: bold;
            text-align: center;
          }

          .old_weekly_price {
            font-weight: 400;
            text-decoration: line-through;
            font-size: 11px;
            color: rgba(255, 255, 255, 0.8);
            font-weight: 500;
          }
        }

        .price_tips {
          font-size: 12px;
          color: #9497A1;
          text-align: right;
          font-style: normal;
          transform: translateY(-5px);
          margin-top: 2px;
          font-weight: 500;
        }
      }

      .close_btn {
        width: 25px;
        margin-top: 20px;
      }
    }

  }

}
</style>
